import { useRouter } from "next/router";
import React, { useContext, useEffect, useState, useTransition } from "react";
import { useForm } from 'react-hook-form'
import settingsModel from "../../models/settings.model";
import useSWR from 'swr'
import Heading from "../../components/Heading.js";
import Link from "next/link";
import SettingsLayout from "./SettingsLayout";
import helper from "../../lib/helper";
import config from "../../lib/config";
const Page = function () {

    const router = useRouter()
    const {
        register,
        handleSubmit,
        watch,
        setValue,
        formState: { errors,isSubmitting },
        setError,
        reset
    } = useForm();
    const { data, mutate } = useSWR('setting', async () => await settingsModel.list(),config.swrConfig)
    useEffect(() => {
        console.log(data?.data);
        reset(data?.data);
    }, [data]);
    const onSubmit = handleSubmit(async (data, event) => {
        const formData = new FormData(event.target);
        await settingsModel.create(formData).then((response) => {
            helper.sweetalert.toast(response?.data?.message, 'success');
            
        }).catch(error => {
            setError('title', { type: 'required', message: error.response?.data?.errors?.title });
        })
    });

    const onSelectFile = (file,name) => {
        // I've kept this example simple by usin;g the first image instead of multiple
        const objectUrl = URL.createObjectURL(file);
        setValue(name+'_preview', objectUrl);
        //setValue("avatar", e.target.files[0]);
    }


    return (
        <>

            <SettingsLayout title="Settings">
                <div className="tab-pane active" id="profile">

                    <h6 className="card-header">General Settings</h6>
                    <form onSubmit={onSubmit}>
                        <div className="card-body">
                            <div className="row">

                                <div className="col-md-auto">
                                    <div className="thumbnail mb-2">
                                        <img src={watch('logo_preview') || watch('logo') || "/images/logo.png"}
                                            className="img-thumbnail mt-1" alt="" height="100px" width="130px" />

                                        <label className="custom-file-upload m-1 w-100">
                                            <input type="file"  {...register('logo',{onChange:()=>onSelectFile(event.target.files[0],'logo')})} className="d-none" accept="image/*" />
                                            <b className="btn btn-dark btn-sm">Upload Logo</b>
                                        </label>

                                    </div>

                                    <div className="thumbnail mb-2">
                                        <img src={watch('favicon_preview') || watch('favicon') || "/images/logo2.png"}
                                            className="img-thumbnail mt-1" alt="" height="100px" width="30px" />

                                        <label className="custom-file-upload m-1 w-100">
                                            <input type="file" {...register('favicon',{onChange:()=>onSelectFile(event.target.files[0],'favicon')})} className="d-none" accept="image/*" />
                                            <b className="btn btn-dark btn-sm">Upload Favicon</b>
                                        </label>

                                    </div>
                                </div>
                                <div className="form-group col-md mb-2">
                                    <div className="form-group mb-2">
                                        <label className="form-label">Title</label>
                                        <input type="text" className="form-control" id="fullName" aria-describedby="fullNameHelp" placeholder="Title" {...register('title')} />
                                    </div>
                                    <div className="form-group mb-2">
                                    <label className="form-label">Email</label>
                                        <input className="form-control autosize" id="bio" placeholder="Contact Email" {...register('email')} />
                                    </div>
                                    <div className="form-group mb-2">
                                    <label className="form-label">Phone Number</label>
                                        <input type="text" className="form-control" id="url" placeholder="Contact Number" {...register('phone')} />
                                    </div>

                                    <div className="form-group mb-2">
                                    <label className="form-label">Address</label>
                                    <textarea className="form-control" rows={5} placeholder="Office Address"  {...register('address')} />
                                </div>
                                </div>
                            </div>
                        </div>
                        <div className="card-footer text-end">
                            <button type="submit" disabled={isSubmitting ? 'disabled' : ''}  className=" btn btn-primary btn-sm">Save</button>

                        </div>
                    </form>
                </div>

            </SettingsLayout>
        </>
    );
};

export default Page;